import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { showResult } from 'infrastructure/hooks/utils';

interface Props {
  conversationId: number;
}

export const getUnregisteredConversationNotesKey = (conversationId: number) => [
  'getUnregisteredConversationNotes',
  conversationId,
];

export const useUnregisteredConversationNotes = ({ conversationId }: Props) => {
  const {
    data: unregisteredConversationNotes,
    refetch,
    fetchStatus,
    isRefetching,
  } = useQuery({
    queryKey: getUnregisteredConversationNotesKey(conversationId),
    queryFn: async () => {
      const API_UNREGISTERED_CONVERSATION_NOTES = `core-2/conversations/${conversationId}/notes`;
      const { data, error } = await dataService.getList(
        API_UNREGISTERED_CONVERSATION_NOTES,
      );

      if (error) {
        showResult(error);
        throw new Error(error);
      }

      return data;
    },
    enabled: !!conversationId,
  });

  return {
    unregisteredConversationNotes,
    fetchUnregisteredConversationNotes: refetch,
    unregisteredConversationNotesLoading:
      fetchStatus === 'fetching' || isRefetching,
  };
};
